<template>
  <div class="signup-page">

    <!-- Header -->
    <header class="signup-header">
      <div class="logo">
         <img src="/images/logo1.png" style="height: 3rem;">
      </div>

      <div class="support-text">
        Need help?
        <a href="javascript:void(0)" @click="gotocon()">Contact Support</a>
      </div>
    </header>

    <!-- Card -->
    <div class="signup-card">

      <!-- Progress -->
      <div class="progress-wrapper">
        <div class="progress-text">
          Step {{ step }} of 3
          <span>{{ progress }}% Complete</span>
        </div>

        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: progress + '%' }"></div>
        </div>
      </div>

      <!-- STEP 1 -->
      <div v-if="step === 1" class="step-content">
        <h1>Create Your Account</h1>
        <p>Start growing your Google reviews today.</p>

        <div class="form-group">
          <label>Full Name</label>
          <input v-model="form.name" placeholder="John Doe" />
        </div>

        <div class="form-group">
          <label>Email</label>
          <input v-model="form.email" placeholder="john@company.com" />
        </div>

        <button class="primary-btn" @click="nextStep">
          Continue
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>
      </div>

      <!-- STEP 2 -->
      <div v-if="step === 2" class="step-content">
        <h1>Business Information</h1>
        <p>Tell us about your business.</p>

        <div class="form-group">
          <label>Legal Business Name</label>
          <input v-model="form.business" placeholder="Acme Corporation" />
        </div>

        <div class="form-group">
          <label>Business Category</label>
          <select v-model="form.category">
            <option disabled value="">Select your industry</option>
            <option value="Restaurant">Restaurant</option>
            <option value="Cafe & Bakery">Cafe & Bakery</option>
            <option value="Fast Food">Fast Food</option>
            <option value="Retail">Retail</option>
            <option value="E-commerce">E-commerce</option>
            <option value="Supermarket & Grocery">Supermarket & Grocery</option>
            <option value="Fashion & Apparel">Fashion & Apparel</option>
            <option value="Electronics">Electronics</option>
            <option value="Furniture & Home Decor">Furniture & Home Decor</option>
            <option value="Automotive">Automotive</option>
            <option value="Car Dealership">Car Dealership</option>
            <option value="Bike Dealership">Bike Dealership</option>
            <option value="Auto Repair & Service">Auto Repair & Service</option>
            <option value="Healthcare">Healthcare</option>
            <option value="Hospital">Hospital</option>
            <option value="Clinic">Clinic</option>
            <option value="Dental Clinic">Dental Clinic</option>
            <option value="Pharmacy">Pharmacy</option>
            <option value="Fitness & Gym">Fitness & Gym</option>
            <option value="Beauty & Salon">Beauty & Salon</option>
            <option value="Spa & Wellness">Spa & Wellness</option>
            <option value="Services">Services</option>
            <option value="IT Services">IT Services</option>
            <option value="Software Company">Software Company</option>
            <option value="Digital Marketing Agency">Digital Marketing Agency</option>
            <option value="Web Development">Web Development</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Education">Education</option>
            <option value="School">School</option>
            <option value="College & University">College & University</option>
            <option value="Coaching Institute">Coaching Institute</option>
            <option value="Training Center">Training Center</option>
            <option value="Real Estate">Real Estate</option>
            <option value="Construction">Construction</option>
            <option value="Interior Design">Interior Design</option>
            <option value="Travel & Tourism">Travel & Tourism</option>
            <option value="Travel Agency">Travel Agency</option>
            <option value="Hotel & Resort">Hotel & Resort</option>
            <option value="Event Management">Event Management</option>
            <option value="Photography & Videography">Photography & Videography</option>
            <option value="Financial Services">Financial Services</option>
            <option value="Banking">Banking</option>
            <option value="Insurance">Insurance</option>
            <option value="Accounting & CA">Accounting & CA</option>
            <option value="Legal Services">Legal Services</option>
            <option value="Logistics & Transport">Logistics & Transport</option>
            <option value="Courier & Delivery">Courier & Delivery</option>
            <option value="Manufacturing">Manufacturing</option>
            <option value="Wholesale">Wholesale</option>
            <option value="Import & Export">Import & Export</option>
            <option value="Agriculture">Agriculture</option>
            <option value="NGO & Non-Profit">NGO & Non-Profit</option>
            <option value="Entertainment">Entertainment</option>
            <option value="Media & Advertising">Media & Advertising</option>
            <option value="Gaming">Gaming</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="form-group">
          <label>Business Location</label>
          <input v-model="form.location" placeholder="City, Country" />
        </div>

        <div class="step-actions">
          <button class="ghost-btn" @click="prevStep" style="width: 20%!important; margin-top: .4rem;">
            Back
          </button>

          <button class="primary-btn" @click="nextStep" style="width: 80%!important;">
            Continue
            <span class="material-symbols-outlined">arrow_forward</span>
          </button>
        </div>
      </div>

      <!-- STEP 3 -->
      <div v-if="step === 3" class="step-content">
        <h1>Secure Your Account</h1>
        <p>Create a strong password.</p>

        <div class="form-group">
          <label>Password</label>

          <div class="password-field">
            <input
              :type="showPassword ? 'text' : 'password'"
              v-model="form.password"
              placeholder="At least 8 characters"
            />

            <span
              class="material-symbols-outlined eye-icon"
              @click="showPassword = !showPassword"
            >
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </span>
          </div>
        </div>


        <div class="form-group">
          <label>Confirm Password</label>

          <div class="password-field">
            <input
              :type="showConfirmPassword ? 'text' : 'password'"
              v-model="form.confirmPassword"
              placeholder="Repeat password"
            />

            <span
              class="material-symbols-outlined eye-icon"
              @click="showConfirmPassword = !showConfirmPassword"
            >
              {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
            </span>
          </div>
        </div>
        <!-- Strength -->
        <div class="strength-wrapper">
          <div class="strength-bar">
            <div class="strength-fill" :style="{ width: strength + '%' }"></div>
          </div>
          <span>{{ strengthLabel }}</span>
        </div>

        <div class="step-actions">
          <button class="ghost-btn" @click="prevStep"  style="width: 20%!important; margin-top: .4rem;">
            Back
          </button>

          <button class="primary-btn" @click="createAcc" :disabled="loading" style="width: 80%!important;">
            {{ loading ? "Creating Account..." : "Create Account" }}
          </button>
        </div>
      </div>

    </div>
    <div class="login-link">
      Already have an account?
      <a href="/login">Login</a>
    </div>

    <!-- Footer -->
    <footer class="signup-footer">
      © 2026 Reviewsfix Inc.
    </footer>

  </div>
</template>
<script>
import { signupUser, updateBusiness } from "@/apis/userapis";
import {useToast} from 'vue-toastification';

export default {
  data() {
    return {
      step: 1,
      loading: false,
      toast:null,
      refBy:"",
      showPassword:false,
      showConfirmPassword:false,
      parent_id:"",
      form: {
        name: '',
        email: '',
        business: '',
        category: '',
        location: '',
        password: '',
        confirmPassword: ''
      }
    }
  },

  computed: {
    progress() {
      return this.step * 33;
    },

    strength() {
      if (!this.form.password) return 0;
      if (this.form.password.length < 6) return 30;
      if (this.form.password.length < 10) return 60;
      return 100;
    },

    strengthLabel() {
      if (this.strength < 40) return 'Weak';
      if (this.strength < 80) return 'Medium';
      return 'Strong';
    }
  },

  methods: {
    gotocon(){
      window.location.href = "https://reviewsfix.com/contact/";
    },
    nextStep() {

      // ✅ STEP VALIDATION
      if (this.step === 1) {

        if (!this.form.name || !this.form.email) {
          this.toast.warning("Name and email required");
          return;
        }
      }

      if (this.step === 2) {

        if (!this.form.business || !this.form.category) {
          this.toast.warning("Business details required");
          return;
        }
      }

      if (this.step < 3) this.step++;
    },

    prevStep() {
      if (this.step > 1) this.step--;
    },

    async createAcc() {

      // ✅ PASSWORD VALIDATION
      if (!this.form.password) {
        this.toast.warning("Password required");
        return;
      }

      if (this.form.password !== this.form.confirmPassword) {
        this.toast.warning("Passwords do not match");
        return;
      }

      this.loading = true;

      try {

        // =========================
        // 1️⃣ CREATE USER
        // =========================
        const res = await signupUser(
          this.form.name,
          this.form.email,
          this.form.password,
          "",
          this.refBy,
          this.parent_id,
          this.business,
          this.category,
          this.location
        );

        if (!res.status) {
          this.toast.success(res.success);
          this.loading = false;
          return;
        }

        const user = res.user;

        // =========================
        // 2️⃣ CREATE BUSINESS
        // =========================
        await updateBusiness(
          user.user_id,
          this.form.business,
          this.form.category,
          "", // description optional
          this.form.location
        );

        // =========================
        // 3️⃣ REDIRECT
        // =========================
       this.toast.success(
          "Account created successfully. Verification link sent to your email. Please verify your account before logging in.",
          {
            timeout: 6000
          }
        );
            sessionStorage.setItem("ldata", JSON.stringify(res.user));
        setTimeout(() => {
         
        window.location.href = "/";
        }, 1000);

      } catch (error) {

        console.error(error);
        this.toast.error("Signup failed");

      }

      this.loading = false;
    }
  },
  mounted(){
    this.toast = useToast();
     const params = new URLSearchParams(window.location.search);
    const refBy = params.get("refBy");
    if (refBy) {
      console.log("Referral By:", refBy);

      this.refBy = refBy; 
      this.parent_id = sessionStorage.getItem("parent_id");
    }
  }
}
</script>
<style scoped>
/* PAGE */
.signup-page {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f6f7f8, rgba(25,127,230,0.05));
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* HEADER */
.signup-header {
  width: 100%;
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  padding: 24px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 20px;
}

.logo-icon {
  background: #197fe6;
  color: white;
  padding: 6px;
  border-radius: 10px;
}

.support-text {
  font-size: 14px;
  color: #64748b;
}

.support-text a {
  color: #197fe6;
  font-weight: 600;
}

/* CARD */
.signup-card {
  width: 100%;
  max-width: 480px;
  background: white;
  border-radius: 18px;
  padding: 36px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
}

/* PROGRESS */
.progress-wrapper {
  margin-bottom: 30px;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
}

.progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #197fe6;
  transition: 0.3s;
}

/* CONTENT */
.step-content h1 {
  font-size: 26px;
  font-weight: 800;
}

.step-content p {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
}

.form-group input,
.form-group select {
  width: 100%;
  height: 48px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 14px;
}

/* BUTTONS */
.primary-btn {
  height: 50px;
  background: #197fe6;
  color: white;
  border-radius: 12px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.ghost-btn {
  flex: 1;
  height: 48px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: white;
}

.step-actions {
  display: flex;
}

/* STRENGTH */
.strength-wrapper {
  margin: 12px 0 20px;
}

.strength-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.strength-fill {
  height: 100%;
  background: #f59e0b;
}

/* FOOTER */
.signup-footer {
  margin: 30px 0;
  font-size: 12px;
  color: #94a3b8;
}

/* MOBILE */
@media (max-width: 768px) {

  .signup-header {
    padding: 18px;
  }

  .signup-card {
    border-radius: 0;
    min-height: 100vh;
    max-width: 100%;
    box-shadow: none;
  }

  .step-content h1 {
    font-size: 22px;
  }

  .step-actions {
    flex-direction: column;
  }
}
/* ================= PAGE ================= */

.signup-page {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f6f7f8, rgba(25,127,230,0.05));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* ================= HEADER ================= */

.signup-header {
  width: 100%;
  max-width: 1100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 20px;
}

.logo-icon {
  background: #197fe6;
  color: white;
  padding: 6px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.support-text {
  font-size: 14px;
  color: #64748b;
}

.support-text a {
  color: #197fe6;
  font-weight: 600;
}

/* ================= CARD ================= */

.signup-card {
  width: 100%;
  max-width: 480px;
  background: white;
  border-radius: 18px;
  padding: 28px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);

  display: flex;
  flex-direction: column;
  gap: 18px;

  overflow: visible;   /* CRITICAL FIX */
}

/* ================= PROGRESS ================= */

.progress-wrapper {
  margin-bottom: 10px;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 8px;
}

.progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #197fe6;
  transition: 0.3s ease;
}

/* ================= CONTENT ================= */

.step-content {
  display: flex;
  flex-direction: column;
  gap: 14px;
  overflow: visible;
}

.step-content h1 {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
}

.step-content p {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 4px;
}

/* ================= FORM ================= */

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.form-group input,
.form-group select {
  width: 100%;
  height: 46px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 14px;
  outline: none;
  transition: all 0.2s ease;
  background: white;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.12);
}

/* ================= BUTTONS ================= */

.primary-btn {
  width: 100%;
  height: 48px;
  background: #197fe6;
  color: white;
  border-radius: 12px;
  font-weight: 700;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  transition: all 0.2s ease;

  margin-top: 6px;     /* FIXES HIDDEN BUTTON */
  flex-shrink: 0;      /* PREVENTS COLLAPSE */
}

.primary-btn:hover {
  background: #166fd1;
  transform: translateY(-1px);
}

.ghost-btn {
  flex: 1;
  height: 46px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: white;
  font-weight: 600;
  color: #475569;
  transition: all 0.2s ease;
}

.ghost-btn:hover {
  background: #f8fafc;
}

/* ================= ACTIONS ================= */

.step-actions {
  display: flex;
  gap: 10px;
  margin-top: 6px;
}

/* ================= STRENGTH ================= */

.strength-wrapper {
  margin: 4px 0 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.strength-bar {
  flex: 1;
  height: 6px;
  background: #e2e8f0;
  border-radius: 20px;
  overflow: hidden;
}

.strength-fill {
  height: 100%;
  background: #f59e0b;
  transition: 0.3s ease;
}

/* ================= FOOTER ================= */

.signup-footer {
  margin: 24px 0;
  font-size: 12px;
  color: #94a3b8;
}

/* ================= MOBILE ================= */

@media (max-width: 768px) {

  .signup-page {
    background: white;
  }

  .signup-header {
    padding: 16px;
  }

  .logo {
    font-size: 18px;
  }

  .signup-card {
    border-radius: 0;
    max-width: 100%;
    box-shadow: none;
    padding: 24px 18px;
    gap: 16px;
  }

  .step-content h1 {
    font-size: 22px;
  }

  .step-actions {
    flex-direction: column;
  }


}

.password-field{
  position:relative;
  display:flex;
  align-items:center;
}

.password-field input{
  width:100%;
  padding-right:40px;
}

.eye-icon{
  position:absolute;
  right:12px;
  cursor:pointer;
  color:#64748b;
  font-size:20px;
}
.login-link{
  margin-top:16px;
  text-align:center;
  font-size:14px;
  color:#64748b;
}

.login-link a{
  color:#197fe6;
  font-weight:600;
  margin-left:4px;
}
</style>